var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedirectlinkicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38672 5.5L11.4867 1.4M11.8867 3.4V1H9.48672M6.38672 1H5.38672C2.88672 1 1.88672 2 1.88672 4.5V7.5C1.88672 10 2.88672 11 5.38672 11H8.38672C10.8867 11 11.8867 10 11.8867 7.5V6.5",
    stroke: "#5F5F5F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectlinkicon);
export default __webpack_public_path__ + "static/media/redirectlinkicon.8c7e478a3cb9fc7fed9f161319e637ef.svg";
export { ForwardRef as ReactComponent };